import React from 'react'
import styled, { css } from 'styled-components'
import { config } from 'utils/breakpoint'
import * as sc from 'constants/style'

export const arrowHeight = 48

export const BodyContainer = styled.div`
  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  h2 {
    font-size: 22px !important;
    font-weight: 800;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin: 0;

    @media screen and (max-width: 767px) {
      font-size: 18px !important;
    }
  }

  h3 {
    margin: 0;
    text-transform: initial;
    font-weight: 600;
    font-size: inherit;
  }

  h4 {
    margin: 0;
    text-transform: initial;
    font-weight: 600;
    font-size: inherit;
  }

  h5 {
    font-size: 11px;
    font-weight: bolder;
    letter-spacing: 2.1px;
    line-height: 2.18;
    margin: 0;
    text-transform: uppercase;
    white-space: nowrap;
  }
`

export const VideoContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['marginBottom', 'marginTop'].includes(prop),
})`
  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: 16px;
  `}

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top: 16px;
  `}
`

export const arrowStyle = css`
  height: ${arrowHeight}px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const dotsStyle = css`
  @media screen and (min-width: ${config.tablet}) {
    right: 92px !important;
  }
  @media screen and (max-width: ${config.tablet}) {
    right: 0px !important;
  }

  li {
    div {
      &::before {
        background: rgba(0, 0, 0, 0.1);
        border: solid 1px ${sc.WHITE_HEX};
      }
    }
  }

  li.slick-active {
    div {
      &::before {
        background: ${sc.WHITE_HEX};
      }
    }
  }
`

export const PostContainer = styled.div`
  ol {
    padding: 0;
    counter-reset: item;
  }

  ol > li {
    margin: 0;
    list-style-type: none;
    counter-increment: item;
  }

  ol > li:before {
    display: inline-block;
    width: 1em;
    padding-right: 1.3em;
    font-weight: 600;
    text-align: right;
    content: counter(item) '.';
  }

  a {
    text-decoration: underline;
  }
`

/** Settings */
export const responsive = [
  {
    breakpoint: 768,
    settings: {
      centerPadding: '32px',
    },
  },
  {
    breakpoint: 450,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: 0,
    },
  },
]
